<template>
  <section ref="popupMenu" @click.stop="noop">
    <div @click.prevent="toggleMenu" ref="trigger" class="toggle-trigger">
      <slot name="trigger"></slot>
    </div>
    <template v-if="rootStore.isMobile">
      <transition name="slide-up">
        <section
          v-show="visible"
          @click="closeMenu"
          class="mobile-menu"
          ref="menu"
        >
          <span class="title" v-if="title">{{ title }}</span>
          <div class="menu-items">
            <slot></slot>
          </div>
        </section>
      </transition>
    </template>

    <template v-else>
      <transition name="fade">
        <section
          v-if="visible"
          @click="closeMenu"
          :class="`menu ${anchorPosition}`"
          ref="menu"
          :style="[position]"
        >
          <div class="menu-items">
            <span class="menu-title" v-if="!!$slots['title']">
              <slot name="title"></slot>
            </span>
            <slot></slot>
          </div>
        </section>
      </transition>
    </template>
    <transition name="fade">
      <div class="backdrop" v-if="visible" @click.stop="closeMenu"></div>
    </transition>
  </section>
</template>
<script>
/**
 * Popup menu component
 * - contains a slot named "trigger" that holds the trigger, e.g. an ellipsis
 * - the rest of the content goes into the default slot, e.g. <menu-item>
 *
 * Properties:
 * - anchorPosition - left, right, top, bottom
 */
export default {
  props: {
    anchorPosition: {
      type: String,
      default: ''
    },
    opened: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      height: 0,
      width: 0,
      visible: this.opened
    }
  },
  watch: {
    opened: function (value, oldValue) {
      this.visible = value
    }
  },
  computed: {
    position() {
      if (!this.visible || !this.$refs.trigger) return

      const rect = this.$refs.trigger.getBoundingClientRect()
      const x = rect.left
      const y = rect.top

      let style = {
        position: 'fixed'
      }

      switch (this.anchorPosition) {
        case 'top':
          style = {
            ...style,
            top: `${y + 20}px`,
            left: `${x - this.width / 2 + 8}px`
          }
          break
        case 'top-right':
          style = {
            ...style,
            top: `${y + 30}px`,
            right: `${document.body.clientWidth - x - rect.width / 2 - 15}px`
          }
          break
        case 'right':
          style = {
            ...style,
            top: `${y + 10 - this.height / 2}px`,
            right: `${document.body.clientWidth - x - 15}px`
          }
          break
        case 'bottom':
          style = {
            ...style,
            top: `${y - this.height - 8}px`,
            left: `${x - this.width / 2 + 8}px`
          }
          break
        case 'left':
          style = {
            ...style,
            top: `${y + 8 - this.height / 2}px`,
            left: `${x + 32}px`
          }
          break
        case 'top-left':
          style = {
            ...style,
            top: `${y + 40 - this.height / 2}px`,
            left: `${x}px`
          }
          break
        default:
          style = {
            ...style,
            top: `${y + 22}px`,
            left: x + 'px'
          }
      }

      return style
    }
  },
  methods: {
    toggleMenu(event) {
      this.y = event.pageY
      this.x = event.pageX

      this.visible = !this.visible

      if (this.visible) {
        this.$nextTick(() => {
          this.height = this.$refs.menu.clientHeight
          this.width = this.$refs.menu.clientWidth
          this.$emit('opened')
        })
      }
    },
    closeMenu() {
      this.visible = false
    },
    noop() {}
  }
}
</script>
<style lang="scss" scoped>
// Mobile styling
.mobile-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: white;
  z-index: 20;
  padding-top: 15px;
  padding-bottom: 10px;
  border-radius: 15px 15px 0 0;
  box-shadow: rgba(96, 96, 96, 0.2) 0 4px 23px;

  .title {
    display: flex;
    font-size: 15px;
    align-items: center;
    font-weight: 500;
    height: 40px;
    padding-left: 12px;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100vh);
  transition: all 150ms ease-in 0s;
}

// Desktop styling
.menu {
  position: absolute;
  width: unset;
  min-width: 140px;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: rgba(96, 96, 96, 0.2) 0 4px 23px;
  background-color: white;
  max-height: 400px;
  overflow: auto;

  .menu-items {
    padding: 15px;
    list-style: none;
    background-color: white;
    border-radius: 5px;
    overflow-y: hidden;
    overflow-y: auto;
    text-align: left;
    hr {
      border: none;
      margin: 2px;
    }
  }
}

.menu-title {
  //font-size: 13px;
  font-weight: 600;
  display: inline-block;
  line-height: 40px;
  padding-left: 12px;
  cursor: default;
}

.toggle-trigger {
  cursor: pointer;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    //color: @dh-color-blue;
  }
}
</style>
